import UserSimpleForm from './UserSimpleForm'

export default UserSimpleForm
